var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__menu--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M22 8H2a1 1 0 010-2h20a1 1 0 010 2zm1 9a1 1 0 00-1-1H2a1 1 0 000 2h20a1 1 0 001-1zm0-5a1 1 0 00-1-1H2a1 1 0 000 2h20a1 1 0 001-1z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }